// Lib
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from '../../../node_module_clones/recompose';

// Utils
import liveCollaborationStoreConnect from './store/liveCollaborationStoreConnect';

// Actions
import {
    liveCollaborationSocketConnect,
    liveCollaborationSocketDisconnect,
    liveCollaborationSocketUpdateChannel,
} from './socket/liveCollaborationSocketActions';

// Selectors
import { getHasLiveCollaborators } from './liveCollaborationSelector';
import { getCurrentBoardId } from '../../reducers/currentBoardId/currentBoardIdSelector';
import { getCurrentUserId } from '../../user/currentUserSelector';

// Hooks
import usePrevious from '../../utils/react/usePrevious';

// Constants
import { currentBoardUserPermissionsSelector } from '../../utils/permissions/elementPermissionsSelector';

const mapStateToProps = createStructuredSelector({
    hasLiveCollaborators: getHasLiveCollaborators,
    currentBoardId: getCurrentBoardId,
    userId: getCurrentUserId,
    currentBoardPermissions: currentBoardUserPermissionsSelector,
});

const mapLiveCollaborationDispatchToProps = (dispatch) => ({
    dispatchLiveCollaborationSocketConnect: ({ channel, userId }) =>
        dispatch(liveCollaborationSocketConnect({ channel, userId })),
    dispatchLiveCollaborationSocketDisconnect: () => dispatch(liveCollaborationSocketDisconnect()),
    dispatchLiveCollaborationSocketUpdateChannel: (channel) => dispatch(liveCollaborationSocketUpdateChannel(channel)),
});

const enhancer = compose(
    connect(mapStateToProps),
    liveCollaborationStoreConnect(null, mapLiveCollaborationDispatchToProps),
);

const LiveCollaborationManager = (props) => {
    const {
        currentBoardId,
        userId,
        hasLiveCollaborators,
        dispatchLiveCollaborationSocketConnect,
        dispatchLiveCollaborationSocketDisconnect,
        dispatchLiveCollaborationSocketUpdateChannel,
    } = props;

    const prevHasLiveCollaborators = usePrevious(hasLiveCollaborators);
    const prevCurrentBoardId = usePrevious(currentBoardId);

    useEffect(() => {
        if (hasLiveCollaborators && !prevHasLiveCollaborators) {
            dispatchLiveCollaborationSocketConnect({ channel: currentBoardId, userId });
        }

        if (!hasLiveCollaborators && prevHasLiveCollaborators) {
            dispatchLiveCollaborationSocketDisconnect();
        }

        if (hasLiveCollaborators && currentBoardId !== prevCurrentBoardId) {
            dispatchLiveCollaborationSocketUpdateChannel(currentBoardId);
        }
    }, [hasLiveCollaborators, prevHasLiveCollaborators, currentBoardId, prevCurrentBoardId]);

    return null;
};

LiveCollaborationManager.propTypes = {
    userId: PropTypes.string,
    currentBoardId: PropTypes.string,
    hasLiveCollaborators: PropTypes.bool,
    currentBoardPermissions: PropTypes.number,
    eventListenerNode: PropTypes.object,
    dispatchLiveCollaborationSocketConnect: PropTypes.func,
    dispatchLiveCollaborationSocketDisconnect: PropTypes.func,
    dispatchLiveCollaborationSocketUpdateChannel: PropTypes.func,
};

export default enhancer(LiveCollaborationManager);
